import * as React from "react";
import { Icon, LargeIcon } from "@utdanningsdirektoratet/icon";
import { cls } from "@utdanningsdirektoratet/utils/cls";
import { capitalize } from "@utdanningsdirektoratet/utils/string";
import styles from "./InpageMessage.module.less";

const getIcon = (type: string): LargeIcon => {
  switch (type) {
    case "info":
      return "circle info";
    case "warning":
      return "warning";
    case "success":
      return "check";
    default:
      return "question";
  }
};

type Color = "darkorange" | "grey" | "lightgrey" | "red" | "green" | "blue" | "darkgrey";

type InpageMessageProps = {
  message: React.ReactNode | string;
  type: "warning" | "info" | "success";
  icon?: LargeIcon | false;
  className?: string;
  color?: Color;
};

const InpageMessage: React.FC<InpageMessageProps> = ({ type, message, icon, className, color }) => {
  const messageIcon = icon || getIcon(type);
  const hasCustomColor = !!color;
  const notificationClass = cls(
    {
      [styles.inpageMessage]: true,
      [styles.inpageMessageGreen]: !hasCustomColor && type === "success",
      [styles.inpageMessageDarkgrey]: !hasCustomColor && type === "warning",
      [styles.inpageMessageBlue]: !hasCustomColor && type === "info",
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      [styles[`inpageMessage${capitalize(color)}`]]: hasCustomColor,
    },
    className
  );

  return (
    <div role="alert" aria-live="polite" className={notificationClass}>
      <Icon icon={messageIcon} type="large" />
      <div className={styles.inpageMessageMessage}>{message}</div>
    </div>
  );
};

export default InpageMessage;
